var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { config } from 'lib-shared-backend-config';
import { Component } from 'react';
import { PrivateMediaPlayer } from 'components/privateMediaPlayer';
export class BrowserTab extends Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.selectedAudio.id &&
            nextProps.selectedAudio.id !== this.props.selectedAudio.id) {
            this.props.waitMusicSelect({ selectedAudio: nextProps.selectedAudio });
            this.props.onSelectedCallback({ selectedAudio: nextProps.selectedAudio });
        }
    }
    componentDidMount() {
        if (this.props.selectedAudio.id) {
            this.props.onSelectedCallback({
                selectedAudio: this.props.selectedAudio,
            });
        }
    }
    selectAudio(audioId = null) {
        if (audioId) {
            const foundAudio = this.props.allAudios.find((a) => a.id === audioId);
            if (foundAudio) {
                this.props.waitMusicSelect({ selectedAudio: foundAudio });
                this.props.onSelectedCallback({ selectedAudio: foundAudio });
            }
            else {
                console.warn('foundAudio', foundAudio);
            }
        }
    }
    getMediaUrl() {
        const { selectedAudio } = this.props;
        return selectedAudio && selectedAudio.master_file_path
            ? `${config.url.files}${selectedAudio.master_file_path}`
            : '';
    }
    render() {
        var _a, _b, _c;
        const audioOptions = [];
        const src = this.getMediaUrl();
        let disabled = true;
        let validateText = this.props.labelError !== undefined && this.props.labelError !== null ? (_jsx("span", Object.assign({ className: "validation-text text-capitalize" }, { children: this.props.labelError }))) : null;
        if (this.props.meta.getAsyncStatus === 'loading') {
            validateText = (_jsx("span", Object.assign({ className: "validation-text text-capitalize" }, { children: "Fetching please wait.." })));
        }
        else if (this.props.meta.uploadAsyncStatus === 'loading') {
            validateText = (_jsx("span", Object.assign({ className: "validation-text text-capitalize" }, { children: "Uploading please wait.." })));
        }
        else if (this.props.meta.getAsyncStatus === 'succeeded') {
            if (this.props.allAudios.length > 0) {
                //validateText = <span className="validation-text text-capitalize ">Select a wait music file</span>
            }
            else {
                validateText = (_jsx("span", Object.assign({ className: "validation-text text-capitalize" }, { children: "You need to upload a music file first - click \"+Add new\"" })));
            }
            disabled = false;
        }
        for (const audio of this.props.allAudios) {
            audioOptions.push(Object.assign(Object.assign({}, audio), { chunk_duration_in_secs: 30 }));
        }
        return (_jsxs("div", { children: [_jsxs("div", Object.assign({ className: 'form-group form-group-select ' +
                        (disabled ? 'disabled' : '') +
                        ((_a = this.props.className) !== null && _a !== void 0 ? _a : '') }, { children: [_jsxs("label", Object.assign({ className: "control-label", htmlFor: "holdMusicSelect" }, { children: ["Select audio ", validateText] })), _jsxs("select", Object.assign({ id: "audio-browser", className: "form-control", name: "audio-browser", value: (_c = (_b = this.props.selectedAudio) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '', onChange: (e) => this.selectAudio(e.target.value), disabled: disabled }, { children: [_jsxs("option", Object.assign({ value: "", hidden: !this.props.optional }, { children: [' ', "-", ' ', this.props.meta.getAsyncStatus === 'loading'
                                            ? 'Loading...'
                                            : 'No audio selected'] })), audioOptions.map((audio) => (_jsx("option", Object.assign({ value: audio.id }, { children: audio.name }), audio.id)))] }))] })), _jsx(PrivateMediaPlayer, { filename: this.props.selectedAudio.name, mediaFile: { src, type: 'audio' } })] }));
    }
}
__decorate([
    boundMethod
], BrowserTab.prototype, "selectAudio", null);
__decorate([
    boundMethod
], BrowserTab.prototype, "getMediaUrl", null);
